document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector("#bulk-order-form");
  if (!form) return;

  var totalPriceEl = document.querySelector("#total-price");

  function calculateTotal() {
    var inputs = form.querySelectorAll('input[name^="updates["]');
    var total = 0;
    inputs.forEach(function (input) {
      var quantity = parseInt(input.value, 10);
      var price = parseFloat(input.dataset.price);
      if (!isNaN(quantity) && quantity > 0 && !isNaN(price)) {
        total += quantity * price;
      }
    });
    if (totalPriceEl) {
      totalPriceEl.textContent = total.toFixed(2);
    }
  }

  // Recalculate total when quantities change
  form.addEventListener("input", function (e) {
    if (e.target.matches('input[name^="updates["]')) {
      calculateTotal();
    }
  });

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var inputs = form.querySelectorAll('input[name^="updates["]');
    var itemsToAdd = [];

    inputs.forEach(function (input) {
      var quantity = parseInt(input.value, 10);
      if (quantity > 0) {
        var variantIdMatch = input.name.match(/\d+/);
        if (variantIdMatch) {
          var variantId = parseInt(variantIdMatch[0], 10);
          itemsToAdd.push({ id: variantId, quantity: quantity });
        }
      }
    });

    if (itemsToAdd.length === 0) {
      alert(
        "Please select at least one variant quantity before adding to the cart."
      );
      return;
    }

    // Add items to the cart, then redirect to the cart page
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(text);
          });
        }
        return response.json();
      })
      .then(() => {
        // Once items are successfully added to the cart, redirect to cart page
        window.location.href = "/cart";
      })
      .catch((error) => {
        console.error("Error adding items to the cart:", error);
        alert("There was an error adding items to the cart. Please try again.");
      });
  });

  // Initial total calculation
  calculateTotal();
});
